// хардкод-мапа от команды контента, потом будет подтягиваться
export const offerAdditionalConditionsMap: Record<string, boolean> = {
    '61714bc21c29aa002098d69b': true,
    '5e95f2d100fb36001b78f858': true,
    '62fca5497abf5000209a6e5b': true,
    '5e9c22189ad83a001b4ae935': true,
    '61a8c1d062e4a0001f3f0ed0': true,
    '5e99eb2ef324ad001b939984': true,
    '5e99ea3df324ad001b939981': true,
    '5e99ec18f324ad001b939987': true,
    '600a6483a0e1900020a3e6af': true,
    '626692584e4b0c00216bf57c': true,
    '5f3a82976f80990020277646': true,
    '620e16c46c85150021be67b7': true,
    '5e625e03dd48ee001b4dcc50': true,
    '5e625cd0341672001baa6766': true,
    '61bca32bc8f861002200f886': true,
    '5fadaac2d12a20001f08a856': true,
    '62667a4e10fcfe0022e755e1': true,
    '5f477c1ca92d73001f5392c5': true,
    '6233231a14fb5000211b0e2f': true,
    '60bf776ca64605001f4d931a': true,
    '5e9c498b308675001b8bd102': false,
    '61f29de76c85150021be669b': true,
    '5e988f68363fc3001b76e173': true,
    '6100f8402cae8c001f1e88d9': true,
    '6231f92714fb5000211b0e28': true,
    '5ea6de2de27d6e001b7a5109': true,
    '5ea6dcbce27d6e001b7a5106': true,
    '6204bdb047da82001f3c62de': true,
    '6321972cc0c43a002291ebe4': false,
    '5ea1b0e26c1f2a001b38c21d': true,
    '6113a9c0303a4200204830da': true,
    '5e9b177ee31da8001b958b41': true,
    '5e981413a66a0f001b32ca05': true,
    '5ea59aef583ae3001c45a6c7': true,
    '5ea59eaae53d59001c2617c0': true,
    '60fa6546e55fef0020e9bf52': true,
    '60fa6266e55fef0020e9bf50': true,
    '5f3287dd275e06001f20c9a6': true,
    '5ed001f47cd99b001fb467b3': true,
    '60139f5f3ca9af001f16b97e': true,
    '63bfeced8cdb6b002abb7d89': false,
    '6317384ed2574c002119cd43': false,
    '5e95c24e15a65c001bab5035': false,
    '5e970a76880e69001b3bc42e': false,
    '5e9c23ee528134001bf93735': false,
    '5e9f255bc0edaa001bc85039': true,
    '62b2e03601f0420020571f03': false,
    '60dc540a041440001f4c6055': false,
    '5e983935efe09e001cac3607': false,
    '5e622de6dd48ee001b4dcc40': true,
    '62e12258dea5a000219abe2c': true,
    '5e96ba5b649990001b0e95a8': true,
    '62ac61365b30d3001f9f1d73': true,
    '616942c81e02fb001f4141bc': true,
    '63f4aa334fbf5c0027643f10': true,
    '61239bd9303a420020483121': true,
    '617be478718b26001f0d0516': true,
    '5e95d2be3261b1001b9b5358': true,
    '63bbe3eb8cdb6b002abb7d86': true,
    '6152d6ff3fbe320020909ad2': true,
    '5e95e436b92fe7001be7598e': true,
    '60478f3ede0253001f648100': false,
    '626676d54e4b0c00216bf56c': true,
    '5e9d4dee98f07d001bc0c9af': true,
    '60ca0148041440001f4c6020': false,
    '5ea9bf1ef160ca001b08e87a': true,
    '5f8e7b3138ba97002164487d': true,
    '5f647b23cb2987001f46d429': true,
    '5ea7294ac2242d001bc8fa0b': false,
    '61a8da5862e4a0001f3f0ed3': false,
    '61a8bf51e1530b0020eb76fb': false,
    '629dd50e5ee02a00237bf42d': false,
    '624d9add291d92002065df96': false,
    '61a8b6b762e4a0001f3f0ec9': false,
    '5ea44ff2f2c326001b003025': false,
    '623b15247cfc8100227a9f75': false,
    '620631aa6c85150021be6771': false,
    '61127bbd303a4200204830ce': false,
    '621f66494386300023ba5bb5': false,
    '61128272303a4200204830d1': false,
    '5ea1c6cad8cd54001ba00b93': true,
    '60bf552cbdc8e3001f0f1f97': false,
    '61813df7a7d400001f6902e1': false,
    '5e9c56949df225001b027757': false,
    '627ce4ec41d2e8001feb8a3d': true,
    '5e9c627f9df225001b027761': true,
    '61a0b21ee1530b0020eb76b2': false,
    '61a0a96ee1530b0020eb76af': false,
    '5e9f342bc0edaa001bc85043': false,
    '5e9f32fe033570001bacb68d': false,
    '5f30cfed468ddb001f1fddfa': false,
    '6196813187efe8002048c84d': false,
    '5e987abd5306ca001b096e8b': false,
    '60bf7220923dc0001f674b30': false,
    '6363550b9a5e5a0025846ec8': true,
    '63625e3a9a5e5a0025846ec6': true,
    '61a0dbcce1530b0020eb76ba': true,
    '622f09e414fb5000211b0e00': true,
    '61a0d4ea62e4a0001f3f0e96': true,
    '61a0d25be1530b0020eb76b6': true,
    '61a0c9fd62e4a0001f3f0e94': true,
    '62c807acc7838d00223ce222': false,
    '62ce7d7f1ef40d0023a43a7d': false,
    '62c80b2228ff850021809499': false,
    '5e9b3d75908d0d001b97b039': false,
    '6203dd6a47da82001f3c62c7': false,
    '6203e37247da82001f3c62ce': false,
    '6203e50c6c85150021be674c': false,
    '6203e06847da82001f3c62ca': false,
    '62063d7247da82001f3c62ec': false,
    '61b99c26c8f861002200f876': true,
    '622f4a001e7f230020a23d00': true,
    '5ea0a5d70973a2001b13691c': false,
    '5e989c51e49359001b8726b3': false,
    '61f3beb46c85150021be66bb': true,
    '61f3d0f547da82001f3c624f': true,
    '5ea19a926c1f2a001b38c21b': false,
    '5ea19471d8cd54001ba00b84': false,
    '62f9f96506e4d50020fabd14': true,
    '62f9f02806e4d50020fabd11': true,
    '62f9f7f57abf5000209a6e55': true,
    '63c660c28cdb6b002abb7d8e': true,
    '63c670318cdb6b002abb7d91': true,
    '5ea01f4fe37305001bfbefd0': false,
    '5ea01ff0544b7a001bd2756e': false,
    '5ea01b58544b7a001bd27568': false,
    '63c7f6098cdb6b002abb7d93': false,
    '620234956c85150021be6721': false,
    '5e9f4149c0edaa001bc8504e': false,
    '62873baf04ae800023d45f7c': false,
    '63ca7adffb2e830026f92f61': false,
    '63ca7711fb2e830026f92f5f': false,
    '5ea7259735bd45001bce49ba': true,
    '62060f576c85150021be6769': false,
    '60ae5de288cb62001fb0a80c': true,
    '5f363e6224ea61001f0354ac': false,
    '5ea48710f2c326001b003037': false,
    '62f4b644897e2a00207a7ce8': true,
    '63d80e3f4cd3b000275717ea': true,
    '617697341c29aa002098d6b1': false,
    '5ea6b5bb35bd45001bce49a2': false,
    '5ea45f85792963001b25cae6': false,
    '6124929c5d935e0021e8e8f2': false,
    '5ea08d0a9ca919001bbd3490': false,
    '5ea08b989ca919001bbd348e': false,
    '60d191fe0614c4001f5d3a26': false,
    '60f6a3c2e55fef0020e9bf3b': false,
    '611b8c28303a420020483106': false,
    '60c0701d88132a001ffc3e82': true,
    '61aa1436e1530b0020eb770e': true,
    '61aa0ad262e4a0001f3f0ee1': true,
    '61aa2e5ae1530b0020eb7710': true,
    '61aa36f0e1530b0020eb7712': true,
    '637484f941a5bc0024a05bff': false,
    '625e7e2a09b60a0020a8ea3c': false,
    '61124b10303a4200204830cc': false,
    '60bf5cf1bdc8e3001f0f1f99': false,
    '5e9c60629df225001b02775f': false,
    '61010ba02cae8c001f1e88db': false,
    '5ea49278792963001b25caf8': true,
    '61375ee543e9b7001fb07542': true,
    '5ea491d6792963001b25caf6': true,
    '61a8e82862e4a0001f3f0eda': false,
    '5fcf4f1df9dcb6001f21caa7': false,
    '61702282339795001ff4051f': false,
    '617027b05b88820020399804': false,
    '5fca2a3546a5d2001f0cd943': false,
    '5fca1d9eef09a8001fc02aae': false,
    '5e9f43c4c0edaa001bc85052': false,
    '5fcf44d4f9dcb6001f21caa3': false,
    '5e9f44ab033570001bacb69e': false,
    '63ecabe14cd3b000275717ef': false,
    '60e6d7b8e55fef0020e9bee3': false,
    '5e989865363fc3001b76e17f': false,
    '5e9899950965ae001b5a4cd9': false,
    '60cb49a6041440001f4c6034': true,
    '60e6b6c6e55fef0020e9becf': false,
    '60e6aed1706a14001f622ec8': false,
    '60e5b665d12578001fe39d50': false,
    '61963ad753bf3a00204decb9': false,
    '61f7c6be47da82001f3c6264': false,
    '60d1be5a041440001f4c604d': false,
    '6008095403fe3d001f016b08': false,
    '5ea08f639ca919001bbd3492': false,
    '6204ee7547da82001f3c62e4': false,
    '5e974ac26254d4001caa063f': false,
    '5f464dd1e2bcb1001fc159b0': true,
    '5f4652171ec901001ffb8278': true,
    '5e9c4545308675001b8bd0fa': true,
    '5e9c4440b32e2a001ca8047c': true,
    '5e95f61e00fb36001b78f85b': true,
    '5e95f7af00fb36001b78f85e': true,
    '5e95db3f6a6640001b655d46': true,
    '5e95dd2a6a6640001b655d49': true,
    '62d51146439b4d0023dff104': true,
    '61a4ac3962e4a0001f3f0e9c': true,
    '5fbf476dec28ef001fa9cc36': true,
    '5e9da62e9c347f001b7d24d9': true,
    '5e9da25badcadc001b139771': true,
    '6156b86c1cb9e70020d4ef02': true,
    '60e55a370614c4001f5d3a9e': true,
    '5e621337341672001baa674c': true,
    '5e5fc1377a66e4001b2ba980': true,
    '5e6211bfdd48ee001b4dcc38': true,
    '5e60fbde341672001baa673c': true,
    '5e621767dd48ee001b4dcc3b': true,
    '5e62185add48ee001b4dcc3d': true,
    '5e9f22fbecf88e001bcb7b81': true,
    '615565231cb9e70020d4eefb': true,
    '63cfc30d8cdb6b002abb7d9a': true,
    '60d5bb8e0614c4001f5d3a35': true,
    '6156da071cb9e70020d4ef07': true,
    '60b5db6388cb62001fb0a81b': true,
    '6242db24b417d4002057e652': true,
    '5ea1f3eed8cd54001ba00b9b': true,
    '5fc6b207c9fe0d001f5c577b': true,
    '5e9b3a847cdd32001baa77b4': true,
    '5e95e240b92fe7001be7598c': true,
    '5e95ee936e1d09001b5f828c': true,
    '61c9b09eb6edaa00211a3a1e': false,
    '5e9f3b42033570001bacb696': false,
    '5e9f3a2bc0edaa001bc85048': false,
    '6156ec3b1cb9e70020d4ef10': true,
    '60b7291fb22d38001f710e25': true,
    '5e9b1e3b83ee7c001bd7b082': true,
    '62f3ad8680299b0023b64dce': true,
    '5e9d537598f07d001bc0c9b1': true,
    '636b66d83ba1870027bdce18': true,
    '5ea4596b792963001b25cae0': true,
    '5e99fd7e8c2fc4001ba67fb4': true,
    '5e9e830eaae063001b19f8df': true,
    '626675c410fcfe0022e755da': true,
    '63295b905d96b20021f3a535': false,
    '5f29c8bc87447d001f7d1500': true,
    '615709591cb9e70020d4ef1a': true,
    '5e9ed105ecf88e001bcb7b7b': true,
    '5e9ecd5bd50b49001bf7992e': true,
    '634d677c32b4d20026a1a4b2': false,
    '615efe71f27c49001fb944f8': true,
    '636e5c83613a8d0026ff8d0b': true,
    '5e9c94e68be3dd001cddf222': true,
    '61c034487bca5d0020bb9649': false,
    '5ffe7f51635c1f002082d757': true,
    '5ea5d336e53d59001c2617e0': true,
    '5e97ffaa9d6f3f001bdb8125': true,
    '5f929b293f4f3b0020333b83': true,
    '5e9c20f69ad83a001b4ae932': true,
    '5f928934f392f9001fb54ab7': true,
    '6156c5811cb9e70020d4ef04': true,
    '5e95c9aa31b105001bb766b8': true,
    '62ff437806e4d50020fabd20': false,
    '62ff494706e4d50020fabd22': false,
    '5e96a0c06b79ca001b78a655': false,
    '60fec596fa626d001f5f169a': false,
    '60febe64fa626d001f5f1696': false,
    '634cf0aa60b5b6002787cb85': false,
    '63159224d2574c002119cd3a': false,
    '612dff9755806f001fa45594': false,
    '5ea5a5c92c2f2e001b8b51ed': false,
    '5ea5a723e53d59001c2617c5': false,
    '6405e8ce4fbf5c0027643f15': false,
    '5e9d579f77954e001b86ddbb': false,
    '5ef1bccc201033001f655e7f': true,
    '5e9aa8fa9aeff5001cf242d6': false,
    '611d117b5d935e0021e8e8e7': false,
    '5ea87c3fa30023001bfeb60e': false,
    '6197d59a53bf3a00204deccd': false,
    '6197a70b87efe8002048c863': false,
    '61963b3153bf3a00204decbb': false,
    '619643cf87efe8002048c847': false,
    '5e9698a301153b001cce7816': false,
    '629eee3a5ee02a00237bf430': false,
    '5ea72301c2242d001bc8fa05': false,
    '6103c6c0ee7a92001f0d1fe3': false,
    '6103d41cee7a92001f0d1fe7': false,
    '6103cdb1ee7a92001f0d1fe5': false,
    '61b316cd62e4a0001f3f0f3a': true,
    '5e9a07e9e4d897001b9fcf55': true,
    '6202658c6c85150021be6734': true,
    '6138663843e9b7001fb0754b': false,
    '61a5ecb7e1530b0020eb76d2': false,
    '60d036e30614c4001f5d3a17': false,
    '60e6e281706a14001f622ee0': false,
    '60b4b2cbb22d38001f710e1b': false,
    '5ea07712544b7a001bd27582': false,
    '5ea077ffe37305001bfbefda': false,
    '5ea07584544b7a001bd2757d': false,
    '60e598d50614c4001f5d3aa5': false,
    '60e595dd041440001f4c60c1': false,
    '5e9c4685308675001b8bd0fd': false,
    '63c5434dfb2e830026f92f58': false,
    '63c540c18cdb6b002abb7d8c': false,
    '60fa48d6e55fef0020e9bf4a': true,
    '60e2b5cb0614c4001f5d3a8e': true,
    '61fb98cf47da82001f3c6281': false,
    '61fba22747da82001f3c6285': false,
    '620398c56c85150021be6740': false,
    '62039d9c47da82001f3c62c4': false,
    '61f1895b03ea91001fd8c92e': false,
    '61f186db3f45b4002176c9a0': false,
    '61a8844562e4a0001f3f0ec0': true,
    '61572061c07fab001f86e0de': true,
    '61a8803ce1530b0020eb76eb': true,
    '614321411cb9e70020d4ee9a': false,
    '62024a9847da82001f3c62b3': false,
    '62024b6d47da82001f3c62b5': false,
    '6202469a6c85150021be672e': false,
    '5e9c9b68e65ad6001b19fbf4': false,
    '5e9c99bd8be3dd001cddf228': false,
    '5fe2df30b6c352001f2a3743': false,
    '60f813f0e55fef0020e9bf40': false,
    '5ea96e80dd9f29001bf05c90': false,
    '5ea8886b2b86a2001bcdbe73': true,
    '61f3c6ec47da82001f3c6248': false,
    '61f3c42147da82001f3c6246': false,
    '5ea1dc6e6c1f2a001b38c22c': false,
    '62667ae74e4b0c00216bf572': false,
    '60b490b588cb62001fb0a816': false,
    '60dacfb9041440001f4c6053': true,
    '60f800f7706a14001f622f37': true,
    '6205112f47da82001f3c62e8': true,
    '5ea6bec335bd45001bce49a8': false,
    '63ae9fa58cdb6b002abb7d83': false,
    '6023c15c99f157001f1b7303': true,
    '6166f83fe16acf0020bcbb2f': true,
    '610ce67720cc3c002083da15': true,
    '6166faab1e02fb001f4141b0': true,
    '6166fbe91e02fb001f4141b3': true,
    '6058b800858c5e001f2cc73f': true,
    '61f1965e03ea91001fd8c931': false,
    '642c108a41da88002b2dcc7b': false,
    '5e9b493c10ea62001b5a3086': false,
    '6203780c6c85150021be673c': false,
    '5ea5d7cee53d59001c2617e2': false,
    '5e9c25599ad83a001b4ae938': true,
    '5e983d97a97711001b4fe3c4': false,
    '5e983ccd0d487e001b7c8916': false,
    '61e6b8363f45b4002176c972': true,
    '62667ed04e4b0c00216bf57a': true,
    '62de741cdea5a000219abe29': false,
    '5f2d263c2934aa001f2810d8': false,
    '5f2cd7ca2934aa001f2810d2': false,
    '620122516c85150021be671c': false,
    '5e96d5b6a1fd92001b5c0c7a': true,
    '625fda715be326001f1abf13': false,
    '61f2ad1c47da82001f3c622d': false,
    '632021c4c0c43a002291ebde': false,
    '61f2a0a16c85150021be669d': false,
    '61f2a80047da82001f3c6228': false,
    '60ccae11041440001f4c603d': false,
    '61f2ba9b6c85150021be66a7': false,
    '61f2c1e647da82001f3c6236': false,
    '5e9c3fc7b32e2a001ca80473': false,
    '60d5952c0614c4001f5d3a32': false,
    '6203e86d47da82001f3c62d2': false,
    '6203e22447da82001f3c62cc': false,
    '60b5ccea88cb62001fb0a818': true,
    '61a639aae1530b0020eb76d8': false,
    '61a633d3e1530b0020eb76d6': false,
    '61a62f3ae1530b0020eb76d4': false,
    '61fe37ba47da82001f3c6296': false,
    '61fe33fa6c85150021be6703': false,
    '61fe3ba56c85150021be6708': false,
    '61fe39c46c85150021be6706': false,
};
